export default [
    'AVI',
    'ACE',
    'ART',
    'HUM'
]